import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { MultiselectorContenidoPaqueteList } from "./multiselectorcontenidopaquetes";

type Entity = models.DescripcionContenidoPaquete;
export interface Props extends kea.ModalProps<number[], boolean, undefined> {
}


/**
* Modal de edición para un DescripcionContenidoPaqueteEdit
*/
export class DescripcionContenidoPaqueteEdit extends React.PureComponent<Props> {

    value = (props: Props) => props.value;
    getField = formfields(() => this.props);

    items = observeResource(resources.ContenidoPaquete.query);

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }

    onChange = async (x: number[]) => {
        this.props.onChange(x);
    }

    render() {
        const value = this.props.value;
        const getField = this.getField;
        const items = this.items;

        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} />]}
                onClose={this.onCerrar}
                title="seleccionar los contenidos de paquetes"
            >
                <kea.Title titulo={"Seleccionar contenidos de paquetes"} >
                </kea.Title>
                <MultiselectorContenidoPaqueteList value={value} onChange={this.onChange} items={items} />
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/descripcionespaquete/edit/components/contenidospaquetes/edit.tsx